import ModalSyncLocationsData from './ModalSyncLocationsData';
export default ModalSyncLocationsData;
